import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { Command } from 'cmdk';

export interface ComboboxGroupProps extends ComponentPropsWithoutRef<'div'> {
  children?: ReactNode;
  heading?: ReactNode;
}

export const ComboboxGroup = ({ className, children, heading, ...rest }: ComboboxGroupProps) => {
  return (
    <Command.Group {...rest} heading={heading} className={className}>
      {children}
    </Command.Group>
  );
};
